import api from "./axios";
import { API_ENDPOINTS } from "../constants";
import { logDebug, logError } from "../common/utils/logger";
import { encryptJourneyQueryValue } from "../common/utils/journeyEncryption";

/** Jersey may return JSON as a parsed object or a JSON string; normalize for callers. */
const normalizeOtpResponseData = (data) => {
  if (data == null) return data;
  if (typeof data === "string") {
    const t = data.trim();
    if (t.startsWith("{") && t.endsWith("}")) {
      try {
        return JSON.parse(t);
      } catch {
        return { raw: data };
      }
    }
    return { message: data };
  }
  return data;
};

export const normalizeOtpIdentifier = (identifier) => {
  const raw = String(identifier ?? "").trim();
  if (!raw) return "";
  if (raw.includes("@")) {
    return raw.toLowerCase();
  }
  const digitsOnly = raw.replace(/\D/g, "");
  return digitsOnly.length > 10 ? digitsOnly.slice(-10) : digitsOnly;
};

export const resolvePreferredOtpIdentifier = (params = {}) => {
  const mobile = normalizeOtpIdentifier(params.mobile ?? params.mobileNumber);
  if (mobile) return mobile;
  return normalizeOtpIdentifier(params.email ?? params.emailAddress);
};

export const generateOtp = async (params = {}) => {
  const {
    mobile,
    mobileNumber,
    email,
    emailAddress,
    applicationNumber,
    customerName,
  } = params;
  const m = normalizeOtpIdentifier(mobile ?? mobileNumber) || undefined;
  const e = normalizeOtpIdentifier(email ?? emailAddress) || undefined;
  const response = await api.post(API_ENDPOINTS.TERM_JOURNEY_GENERATE_OTP, {
    mobile: m,
    email: e,
    applicationNumber: applicationNumber ? encryptJourneyQueryValue(applicationNumber) : undefined,
    customerName,
  });

  return normalizeOtpResponseData(response?.data);
};

export const verifyOtp = async (identifier, otp) => {
  try {
    const normalizedIdentifier = normalizeOtpIdentifier(identifier);
    const response = await api.post(API_ENDPOINTS.TERM_JOURNEY_VERIFY_OTP, {
      identifier: normalizedIdentifier,
      otp,
    });

    const normalized = normalizeOtpResponseData(response?.data);
    logDebug("[verifyOtp] Term journey OTP verification response:", {
      httpStatus: response?.status,
      identifier: normalizedIdentifier,
      data: normalized,
    });
    return normalized;
  } catch (error) {
    const normalizedErrorData = normalizeOtpResponseData(error?.response?.data);
    logError("[verifyOtp] Term journey OTP verification failed:", {
      httpStatus: error?.response?.status,
      identifier: normalizeOtpIdentifier(identifier),
      data: normalizedErrorData,
    });
    throw error;
  }
};